/**
 * ResultModal component.
 * Shows result after puzzle is finished.
 */

import { Status } from '@daily-puzzle/shared';
import './ResultModal.css';

export interface ResultModalProps {
    /** Current status */
    status: Status;
    /** Share text */
    shareText: string;
    /** Callback to share */
    onShare: () => void;
    /** Callback to close modal and view puzzle */
    onClose: () => void;
    /** Callback to reveal (when missed) */
    onReveal?: () => void;
    /** Whether share was just copied */
    shareCopied?: boolean;
}

const CONTENT = {
    [Status.Solved]: {
        title: 'Solved',
        subtitle: 'Good eye.',
    },
    [Status.Missed]: {
        title: 'Missed',
        subtitle: 'Back tomorrow.',
    },
    [Status.Revealed]: {
        title: 'Revealed',
        subtitle: 'See you tomorrow.',
    },
    [Status.InProgress]: {
        title: '',
        subtitle: '',
    },
};

export function ResultModal({
    status,
    shareText,
    onShare,
    onClose,
    onReveal,
    shareCopied,
}: ResultModalProps) {
    if (status === Status.InProgress) return null;

    const content = CONTENT[status];

    return (
        <div className="result-modal-overlay">
            <div className="result-modal" role="dialog" aria-labelledby="result-title">
                <h2 id="result-title" className="result-title">
                    {content.title}
                </h2>
                <p className="result-subtitle">{content.subtitle}</p>

                <div className="result-share-preview">
                    <pre>{shareText}</pre>
                </div>

                <div className="result-actions">
                    <button
                        className="result-button result-button--primary"
                        onClick={onShare}
                    >
                        {shareCopied ? 'Copied!' : 'Share'}
                    </button>

                    {status === Status.Missed && onReveal && (
                        <button
                            className="result-button result-button--secondary"
                            onClick={onReveal}
                        >
                            Show solution
                        </button>
                    )}

                    <button
                        className="result-button result-button--tertiary"
                        onClick={onClose}
                    >
                        View puzzle
                    </button>
                </div>
            </div>
        </div>
    );
}

